// extracted by mini-css-extract-plugin
module.exports = {"title":"FAMBilling-module__title--3rFJa","text":"FAMBilling-module__text--3owcF"};